// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Hbnm","inputWrap":"Table_inputWrap__1zMJK","col":"Table_col__1K-0Y","bmiTooltip":"Table_bmiTooltip__36ad3"};